<template>
  <div class="footer-box">
    <ul>
      <li>
        <a href="#">新手入门</a>
      </li>
      <li>
        <router-link to="/downLoad">产品下载</router-link>
      </li>
      <!-- <li>
        <a href="#">帮助中心</a>
      </li>
      <li>
        <a href="#">联系我们</a>
      </li> -->
    </ul>
	  <div class="desc">@ 2024 yundesktop Inc. 重庆顿硕科技发展有限公司 All rights reserved. 
      <a href="https://beian.miit.gov.cn/" target="_blank">渝ICP备2023010842号</a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less"scoped>
.footer-box {
  min-width: 1200px;
  width: 100%;
  height: 90px;
  background: #1b1c2a;
  display: flex;
  align-items: center;
  flex-direction: column;
  ul {
    // margin-bottom: 10px;
    li {
      list-style-type: none;
      display: inline-block;
      padding: 0px 10px;
      border-right: 1px solid #757477;
      cursor: pointer;
      height: 14px;
      line-height: 14px;
      a {
        color: #8b8a8a;
        text-decoration: none;
		font-size: 14px;
		&:hover{
			color: #fff;
		}
      }
	  &:last-child{
		border-right:0px
	  }
    }
  }
  .desc{
    color: #8b8a8a;
    font-size: 12px;
    a{
      color: #8b8a8a;
    }
  }
}
</style>
